import React from 'react';
import { useParams } from 'react-router-dom';
//Redux
import { useDispatch, useSelector } from 'react-redux'; 

const withCtrInsertDocentes = (WrappedComponent) => props => {

  const { idCapacitacion, idProyecto } = useParams()
  const id = idCapacitacion || idProyecto

  const datos = useSelector(state => state.control_capacitacion.area_trabajo.datos)
  const docentesFiltro = datos[id] ? datos[id].docentes_filtro : []

  return ( 
    <WrappedComponent
      {...props}
      datos={docentesFiltro}
    />
   );
}
 
export default withCtrInsertDocentes;